import { useMemo } from 'react';
import { ADMIN, BRISTEC_ADMIN, MODERATOR } from '../../../const/constants';
import { useAuth } from '../../../hooks/useAuth';
import type { PrescriptionDto } from '../types/PrescriptionDto';

export const PERMISSION_MESSAGE = 'You do not have the required permissions';
export const VERIFIED_MESSAGE = 'Record has been processed';

export function usePrescriptionAuth(prescription?: PrescriptionDto) {
	const auth = useAuth();

	const authMessage = useMemo(() => {
		if (![MODERATOR, ADMIN, BRISTEC_ADMIN].includes(auth.getRole()))
			return PERMISSION_MESSAGE;
	}, []);

	const verifiedMessage = useMemo(() => {
		if (prescription?.verifiedBy) return VERIFIED_MESSAGE;
	}, [[prescription?.verifiedBy]]);

	return { authMessage, verifiedMessage };
}
